export default "__VITE_ASSET__DvVU7f4k__"